import script from "./GordonRamsay.vue?vue&type=script&setup=true&lang=js"
export * from "./GordonRamsay.vue?vue&type=script&setup=true&lang=js"

import "./GordonRamsay.vue?vue&type=style&index=0&id=c9fcddd4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9fcddd4"]])

export default __exports__